<template>
  <div class="main">
    <div class="form-row">
      <div class="form-field">
        <img v-show="waite1" src="@/assets/wait.gif" class="waite" />
      </div>
      <div class="form-field" v-show="!waite1">
        <label for="user-select">Выберите подразделение:</label>
        <select id="user-select" v-model="idUnit">
          <option v-for="(unit, key) in showUnit" :value="unit.ID" :key="key">{{
            unit.NAME
          }}</option>
        </select>
      </div>
      <div class="form-field" v-show="!waite1">
        <label for="group-select">Выберите группу доступа:</label>
        <select id="group-select" v-model="idGroup">
          <option v-for="(group, key) in groups" :value="group.ID" :key="key">{{
            group.NAME
          }}</option>
        </select>
      </div>
      <div class="form-field">
        <label for="auto-number-input">Введите номер ТС:</label>
        <input id="auto-number-input" v-model="autoData.number" type="text" />
      </div>
      <div class="form-field">
        <label for="fio-input">Введите ФИО:</label>
        <input id="fio-input" v-model="autoData.fio" type="text" />
      </div>
      <div class="form-field">
        <label for="number-plant-input">Введите номер участка:</label>
        <input
          id="number-plant-input"
          v-model="autoData.numberPlant"
          type="text"
        />
      </div>
      <div class="form-field">
        <label for="rfid-input">Введите RFID:</label>
        <input id="rfid-input" v-model="autoData.rfid" type="text" />
      </div>
      <div class="form-field">
        <img v-show="waite" src="@/assets/wait.gif" class="waite" />
        <button v-show="!waite" @click="sendAutoData">Отправить</button>
      </div>
    </div>
    <div class="form-row" v-if="info">{{ info }}</div>
  </div>
</template>

<script>
import config from "@/config";

export default {
  name: "PassAdd",
  data() {
    return {
      url: config.backend_url,
      units: [],
      groups: [],
      unitHaveChildren: [],
      autoData: {
        rfid: null,
        numberPlant: null,
        fio: null,
        number: null
      },
      idUnit: false,
      idGroup: false,
      info: false,
      waite1: false,
      waite: false
    };
  },
  computed: {
    showUnit: function() {
      let self = this;
      return this.units.filter(function(unit) {
        return !self.unitHaveChildren.includes(unit.ID);
      });
    }
  },
  methods: {
    sendAutoData: function() {
      let self = this;
      self.waite = true;
      self.autoData.unitId = self.idUnit;
      self.autoData.groupId = self.idGroup;
      let data = {
        url: self.url + "parsec/add-rfid/",
        data: self.autoData,
        method: "POST"
      };
      this.$store.dispatch("query/sendRequest", data).then(function(response) {
        let data = response.data;
        if (data.error) {
          self.info = data.error;
        } else {
          self.info = data.parsecPersonID
            ? "ID пользователя: " + data.parsecPersonID
            : "Ошибка добавления пропуска в Parsec";
        }
        self.waite = false;
      });
    }
  },
  mounted() {
    let self = this;
    self.waite1 = true;
    let data = {
      url: this.url + "parsec/get-units-hierarhy/",
      data: {},
      method: "POST"
    };
    this.$store
      .dispatch("query/sendRequest", data)
      .then(response => {
        let data = response.data;
        data.forEach(function(unit) {
          if (!self.unitHaveChildren.includes(unit.PARENT_ID))
            self.unitHaveChildren.push(unit.PARENT_ID);
        });
        if (!data.error) {
          self.units = data;
        } else {
          self.info = "Ошибка получения списка подразделений";
        }
      })
      .then(() => {
        let data = {
          url: this.url + "parsec/get-access-group/",
          data: {},
          method: "POST"
        };
        this.$store.dispatch("query/sendRequest", data).then(response => {
          let data = response.data;
          if (!data.error) {
            self.groups = data;
          } else {
            self.info = "Ошибка получения списка групп";
          }
          self.waite1 = false;
        });
      });
  }
};
</script>
